import I18n from 'I18n';
// Takes in the featureId, productLine, tier and boolean for hasFeature and returns null or the appropriate short limit object
// with the keys showCheck or value.
export const getProductFeatureShortLimitConfig = ({
  featureId,
  productLine,
  currentProductLevel,
  hasFeature
}) => {
  if (!hasFeature) return null; // @ts-expect-error not migrated to TS

  const hasShortLimitsLanguage = I18n.lookup(`pricing-pages.features.${featureId}.shortLimits`);

  if (!hasShortLimitsLanguage) {
    return {
      showCheck: true
    };
  } // @ts-expect-error not migrated to TS


  const hasHubSpecificLanguage = I18n.lookup(`pricing-pages.features.${featureId}.shortLimits.${productLine}`);
  const keyToUse = hasHubSpecificLanguage ? productLine : 'default';

  if ( // @ts-expect-error not migrated to TS
  I18n.lookup(`pricing-pages.features.${featureId}.shortLimits.${keyToUse}.${currentProductLevel}`)) {
    return {
      value: `pricing-pages.features.${featureId}.shortLimits.${keyToUse}.${currentProductLevel}`
    };
  }

  return {
    showCheck: true
  };
}; // Takes in the featureId, productLine, and editions array and returns the appropriate array of
// long limits objects, plus any pretext of the form {label, value, key}

export const getProductFeatureLongLimitConfig = ({
  featureId,
  productLine,
  allProductLevels
}) => {
  const sections = []; // @ts-expect-error not migrated to TS

  const hasHubSpecificLanguage = I18n.lookup(`pricing-pages.features.${featureId}.longLimits.${productLine}`);
  const keyToUse = hasHubSpecificLanguage ? productLine : 'default';

  if ( // @ts-expect-error not migrated to TS
  I18n.lookup(`pricing-pages.features.${featureId}.longLimits.${keyToUse}.pretext`)) {
    sections.push({
      key: 'pretext',
      value: `pricing-pages.features.${featureId}.longLimits.${keyToUse}.pretext`
    });
  }

  allProductLevels.forEach(productLevel => {
    if ( // @ts-expect-error not migrated to TS
    I18n.lookup(`pricing-pages.features.${featureId}.longLimits.${keyToUse}.${productLevel}`)) {
      sections.push({
        key: productLevel,
        label: `pricing-pages.tooltips.labels.${productLevel}`,
        value: `pricing-pages.features.${featureId}.longLimits.${keyToUse}.${productLevel}`
      });
    }
  });
  return sections;
};